import React from 'react';
import logo from '../../logo.jpeg';

const Checkbox = ({ label, checked }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11px', margin: '3px 0' }}>
    <div style={{
      width: '12px',
      height: '12px',
      border: '1.5px solid #000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: '10px',
      lineHeight: '1',
      boxSizing: 'border-box'
    }}>
      {checked ? '✓' : ''}
    </div>
    <span>{label}</span>
  </div>
);

const AdmissionFormPrintView = ({ student }) => {
  if (!student) return null;

  const today = new Date().toLocaleDateString('en-GB');

  const coursesList = student.courses || (student.course ? [student.course] : []);
  const normalizedCourses = coursesList.map(c => String(c).toLowerCase().replace(/[\s_-]/g, ''));

  const checkCourse = (keywords) => {
    return normalizedCourses.some(c => keywords.some(kw => c.includes(kw)));
  };

  const isBanking = checkCourse(['banking', 'ibps']);
  const isSSC = checkCourse(['ssc', 'cgl', 'staff']);
  const isMBA = checkCourse(['mba', 'cat', 'mat', 'cet']);
  const isJEE = checkCourse(['jee', 'neet']);
  const isPolice = checkCourse(['police', 'military', 'training']);
  const isTAIT = checkCourse(['tait', 'maha']);
  const isMPSC = checkCourse(['mpsc']);
  const isNET = checkCourse(['net', 'ugc', 'csir', 'set']);

  const qualVal = String(student.qualification || '').toLowerCase();
  
  const isSSCQual = qualVal.includes('ssc') || qualVal.includes('10th') || qualVal.includes('tenth') || !!student.marks10th;
  const isHSCQual = qualVal.includes('hsc') || qualVal.includes('12th') || qualVal.includes('twelfth') || !!student.marks12th;
  const isGradQual = qualVal.includes('grad') || qualVal.includes('degree') || qualVal.includes('bachelor') || qualVal.includes('b.sc') || qualVal.includes('b.com') || qualVal.includes('b.a') || qualVal.includes('be') || qualVal.includes('btech');
  const isPostgradQual = qualVal.includes('postgrad') || qualVal.includes('master') || qualVal.includes('m.sc') || qualVal.includes('m.com') || qualVal.includes('m.a') || qualVal.includes('mba') || qualVal.includes('post graduate');

  const docVal = String(student.documentSubmitted || '').toLowerCase();
  const docAadhar = docVal.includes('aadhar') || docVal.includes('adhar');
  const docSSC = docVal.includes('ssc');
  const docHSC = docVal.includes('hsc');
  const docOther = docVal.includes('other');

  return (
    <div className="admission-print-container printable-admission-view" style={{ padding: '10px', boxSizing: 'border-box' }}>
      <div style={{ 
        width: '100%', 
        fontFamily: 'Arial, sans-serif', 
        color: '#000', 
        boxSizing: 'border-box', 
        border: '2px solid #000', 
        padding: '20px 22px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        
        {/* Header Block Box */}
        <div style={{ 
          border: '2px solid #000', 
          display: 'flex', 
          alignItems: 'center', 
          gap: '18px', 
          padding: '10px 14px', 
          marginBottom: '14px' 
        }}>
          <img src={logo} alt="Logo" style={{ width: '76px', height: '76px', objectFit: 'contain', border: '1.5px solid #000', padding: '2px' }} />
          <div style={{ flex: 1 }}>
            <h1 style={{ margin: '0 0 4px 0', fontSize: '21px', fontWeight: 'bold', letterSpacing: '0.5px' }}>BK GROUP OF EDUCATION</h1>
            <p style={{ margin: '1.5px 0', fontSize: '11px', fontWeight: '500' }}>2nd Floor, Gajanan Plaza, Behind Lotus Capital Building,</p>
            <p style={{ margin: '1.5px 0', fontSize: '11px', fontWeight: '500' }}>Gharpure Ghat Road, Ashok Stambh, Nashik-422002, Maharashtra</p>
            <p style={{ margin: '1.5px 0', fontSize: '11px', fontWeight: '500' }}>Email : bkgroupofeducation1@gmail.com</p>
            <p style={{ margin: '1.5px 0', fontSize: '11px', fontWeight: '500' }}>Contact No. : 8888301363</p>
          </div>
        </div>

        {/* Form Title */}
        <div style={{ textAlign: 'center', marginBottom: '14px' }}>
          <h2 style={{ margin: 0, fontSize: '17px', fontWeight: 'bold', textDecoration: 'underline', letterSpacing: '1px' }}>ADMISSION FORM</h2>
        </div>

        {/* Reg No, Date and Photo Row */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '14px' }}>
          <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
            <div><strong>Reg No : {student.fingerprint_id || '_______'}</strong></div>
            <div><strong>Admission Date : {student.enquiryDate || today}</strong></div>
          </div>
          
          {/* Photo box matching the screenshot size/look - only shown if student has a photo */}
          {student.photo && student.photo !== '' ? (
            <div style={{ 
              width: '115px', 
              height: '140px', 
              border: '2px solid #000', 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center', 
              justifyContent: 'center', 
              padding: '5px',
              boxSizing: 'border-box'
            }}>
              <img 
                src={student.photo.startsWith('http') || student.photo.startsWith('data:') ? student.photo : `${window.location.protocol}//${window.location.hostname}${window.location.protocol === 'https:' ? '' : ':8080'}${student.photo}`} 
                alt="Student" 
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
              />
            </div>
          ) : null}
        </div>

        {/* Section: Personal Details */}
        <div style={{ marginBottom: '14px' }}>
          <h3 style={{ margin: '0 0 8px 0', fontSize: '14px', fontWeight: 'bold', textDecoration: 'underline' }}>Personal Details</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: '170px 1fr', rowGap: '8px', fontSize: '12px' }}>
            <span style={{ fontWeight: 'bold' }}>1. Student Name</span>
            <span>: {student.name || ''}</span>
            
            <span style={{ fontWeight: 'bold' }}>2. Birth Date</span>
            <span>: {student.dob || ''}</span>

            <span style={{ fontWeight: 'bold' }}>3. Gender</span>
            <span>: {student.gender || ''}</span>

            <span style={{ fontWeight: 'bold' }}>4. Document Submitted</span>
            <div style={{ display: 'flex', gap: '14px', alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={{ marginRight: '2px' }}>:</span>
              <Checkbox label="Aadhar Card" checked={docAadhar} />
              <Checkbox label="SSC Certificate" checked={docSSC} />
              <Checkbox label="HSC Certificate" checked={docHSC} />
              <Checkbox label="Other" checked={docOther} />
            </div>

            <span style={{ fontWeight: 'bold' }}>5. Qualification</span>
            <div style={{ display: 'flex', gap: '18px', alignItems: 'center' }}>
              <span style={{ marginRight: '2px' }}>:</span>
              <Checkbox label="SSC" checked={isSSCQual} />
              <Checkbox label="HSC" checked={isHSCQual} />
              <Checkbox label="Graduate" checked={isGradQual} />
              <Checkbox label="Postgraduate" checked={isPostgradQual} />
            </div>

            <span style={{ fontWeight: 'bold' }}>6. School/College</span>
            <span>: {student.previousSchool || ''}</span>
          </div>
        </div>

        {/* Section: Communication Details */}
        <div style={{ marginBottom: '14px' }}>
          <h3 style={{ margin: '0 0 8px 0', fontSize: '14px', fontWeight: 'bold', textDecoration: 'underline' }}>Communication Details</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: '150px 175px 110px 1fr', rowGap: '8px', fontSize: '12px' }}>
            <span style={{ fontWeight: 'bold' }}>7. Primary Mob. no</span>
            <span>: {student.studentPhone || student.studentContact || ''}</span>
            
            <span style={{ fontWeight: 'bold' }}>8. Email Id</span>
            <span style={{ wordBreak: 'break-all' }}>: {student.email || ''}</span>

            <span style={{ fontWeight: 'bold' }}>9. Secondary Mob. no</span>
            <span>: {student.parentPhone || student.motherPhone || student.fatherPhone || ''}</span>
            
            <span style={{ fontWeight: 'bold' }}>10. Address</span>
            <span>: {student.address || ''}</span>
          </div>
        </div>

        {/* Section: Course Details */}
        <div style={{ marginBottom: '14px' }}>
          <h3 style={{ margin: '0 0 8px 0', fontSize: '14px', fontWeight: 'bold', textDecoration: 'underline' }}>Course Details</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '20px', rowGap: '6px', paddingLeft: '4px' }}>
            <Checkbox label="IBPS-Banking" checked={isBanking} />
            <Checkbox label="Staff Selection Commission (SSC)-CGL" checked={isSSC} />
            <Checkbox label="MBA-(CAT/MAT/MH CET)" checked={isMBA} />
            <Checkbox label="JEE/NEET" checked={isJEE} />
            <Checkbox label="Police/Military/ Training" checked={isPolice} />
            <Checkbox label="MAHA-TAIT" checked={isTAIT} />
            <Checkbox label="MPSC (Group B & C)" checked={isMPSC} />
            <Checkbox label="UGC NET/MH SET/CSIR NET" checked={isNET} />
          </div>
        </div>

        {/* Section: Other Details */}
        <div style={{ marginBottom: '14px' }}>
          <h3 style={{ margin: '0 0 6px 0', fontSize: '14px', fontWeight: 'bold', textDecoration: 'underline' }}>Other Details</h3>
        </div>

        {/* Section: Declaration */}
        <div style={{ marginBottom: '16px' }}>
          <h4 style={{ margin: '0 0 4px 0', fontSize: '13px', fontWeight: 'bold' }}>Declaration</h4>
          <p style={{ margin: 0, fontSize: '11px', lineHeight: '1.4', fontWeight: '500' }}>
            I hereby declare that above furnished information are true to the best of my knowledge and belief.
          </p>
        </div>
        {/* Bottom Place/Date - auto-filled values */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
            <div><strong>Place :</strong> {student.branch || 'Nashik'}</div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
            <div><strong>Date :</strong> {student.enquiryDate || today}</div>
          </div>
        </div>

        {/* Terms */}
        <div style={{ borderTop: '1.5px solid #000', padding: '8px 0 0 0' }}>
          <strong style={{ fontSize: '11px', display: 'block', marginBottom: '4px' }}>Terms & Conditions :</strong>
          <div style={{ fontSize: '10px', color: '#444', lineHeight: '1.4' }}>
            <div>1. All above mentioned Amount once paid are non refundable in any case whatsoever.</div>
            <div>2. Late payment will attract extra charges.</div>
            <div>3. Fees are non-transferable to another student/course.</div>
          </div>
          <div style={{ textAlign: 'center', fontSize: '10px', fontStyle: 'italic', marginTop: '6px', color: '#333', fontWeight: 'bold' }}>
            This is computer-generated admission form. No signature is required for validation.
          </div>
        </div>
      </div>

      <style>{`
        .printable-admission-view {
          visibility: hidden;
          position: absolute;
          pointer-events: none;
          height: 0;
          overflow: hidden;
        }
        @media print {
          @page {
            size: A4 portrait;
            margin: 0 !important;
          }
          
          body.print-blank-admission .blank-admission-container {
            display: block !important;
            visibility: visible !important;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            z-index: 999999 !important;
          }

          body.print-blank-admission .blank-admission-container .printable-admission-view,
          body.print-admission .printable-admission-view {
            display: block !important;
            visibility: visible !important;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            height: auto !important;
            background: white !important;
            margin: 0 auto !important;
            padding: 8mm 10mm 8mm 10mm !important;
            box-sizing: border-box !important;
            z-index: 999999 !important;
            page-break-after: avoid !important;
            page-break-inside: avoid !important;
            break-after: avoid !important;
            break-inside: avoid !important;
          }

          body.print-all-admissions .all-admissions-print-container .printable-admission-view,
          body.print-processed-admissions .processed-admissions-print-container .printable-admission-view {
            display: block !important;
            visibility: visible !important;
            position: relative !important;
            width: 100% !important;
            height: auto !important;
            background: white !important;
            margin: 0 auto !important;
            padding: 8mm 10mm 8mm 10mm !important;
            box-sizing: border-box !important;
            page-break-after: always !important;
            page-break-inside: avoid !important;
            break-after: page !important;
            break-inside: avoid !important;
          }

          .printable-admission-view > div {
            margin: 0 auto !important;
            max-width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AdmissionFormPrintView;
